import request from '@/utils/request'

// 查询运动项目下拉列表
export function getSportProjectSelectList(data) {
  return request({
    url: '/sys/sport/project/allList',
    method: 'post',
    data
  })
}

// 查询运动项目列表
export function getSportProjectList(data) {
  return request({
    url: '/sys/sport/project/list',
    method: 'post',
    data
  })
}

// 新增运动类型
export function addSportType(data) {
  return request({
    url: '/type/add',
    method: 'post',
    data,
    debounce: true,
  })
}

// 删除运动类型
export function delSportType(id) {
  return request({
    url: '/type/del/'+id,
    method: 'delete',
    debounce: true,
  })
}

// 修改动作类型
export function editSportType(data) {
  return request({
    url: '/type/edit',
    method: 'put',
    data,
    debounce: true,
    }
  )
}

// 获取动作类型详细信息
export function getSportTypeInfo(id) {
  return request({
    url: '/type/info/'+id,
    method: 'get',
  })
}

// 查询动作类型列表
export function getSportTypeList(data) {
  return request({
    url: '/type/pageList',
    method: 'post',
    data
  })
}
